import API from "./index";

export const fetchCategories = async (params = {}) => {
    const response = await API.get("/categories", { params });
    return response.data;
};

export const createCategory = async (payload) => {
    const response = await API.post("/categories", payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const updateCategory = async (id, payload) => {
    const response = await API.put(`/categories/${id}`, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const deleteCategory = async (id) => {
    const response = await API.delete(`/categories/${id}`);
    return response.data;
};
